import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../page.css";
import "../home.css";

const options = [
  {
    id: "northern-zanzibar",
    title: "Northern plus Zanzibar",
    text: "Serengeti or Ngorongoro days, then a soft landing on the island for beach and Stone Town time.",
  },
  {
    id: "southern-zanzibar",
    title: "Southern plus Zanzibar",
    text: "Ruaha or Nyerere first for quieter bush, then fly or connect onward to Zanzibar.",
  },
  {
    id: "short-add-on",
    title: "Short safari add on",
    text: "Two to four game days when the main focus is Zanzibar, with parks chosen to fit your dates.",
  },
];

function BeachAndSafari() {
  const { hash } = useLocation();

  useEffect(() => {
    document.title = "Beach and Safari · Mirrorkhan Tours";
  }, []);

  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 50);
    return () => window.clearTimeout(timer);
  }, [hash]);

  return (
    <section className="page section-block">
      <div className="container">
        <div className="row mb-4 mb-lg-5" data-reveal="true">
          <div className="col-lg-8">
            <p className="eyebrow">
              <Link to="/safaris" className="text-decoration-none">
                Safaris
              </Link>
            </p>
            <h1 className="mb-3">Beach and Safari</h1>
            <p className="page-lead mb-0">
              Mainland game days shaped around a Zanzibar finish. Choose the
              northern classics, a southern wilder loop, or a short add on.
            </p>
          </div>
        </div>

        <div className="row g-4">
          {options.map((option, index) => (
            <div
              className="col-md-4"
              key={option.id}
              id={option.id}
              data-reveal="true"
              data-reveal-delay={String(index * 90)}
            >
              <article className="approach-item h-100">
                <h2 className="h4 mb-2">{option.title}</h2>
                <p className="mb-3">{option.text}</p>
                <Link className="text-link" to="/contact">
                  Ask about this plan
                </Link>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BeachAndSafari;
